<template>
  <div id="app"
    ref="app"
    :class="{open: is_dev_mode}">
    <app-header />
    <process />
    <pages />
  </div>
</template>

<script>
import AppHeader from './components/appHeaderComponent.vue'
import Process from './components/processComponent.vue'
import Pages from './components/pagesComponent.vue'

export default {
  name: 'app',

  created() {
    this.hijackHistoryState()
    this.$store.dispatch('get_planner_url')
  },

  data() {
    return {
      is_dev_mode : process.env.NODE_ENV == 'development'
    }
  },

  components: {
    'app-header' : AppHeader,
    'process' : Process,
    'pages' : Pages,
  },

  methods: {
    hijackHistoryState() {

      // Best working solution for modern browsers
      // Some browers like chome need activities on page before hijack works (adds-protection)
      var _this = this
      history.pushState(null, document.title, location.href)
      window.addEventListener('popstate', function (event) {

        if (_this.$refs.app !== undefined && _this.$refs.app.className !== 'open')
          history.back()

        if(_this.$route.name == 'dakcheck') _this.$refs.app.className = ''
        if(_this.$route.name == 'analyse') _this.$router.push('/')
        if(_this.$route.name == 'verbruik') _this.$router.push('/analyse')
        if(_this.$route.name == 'gegevens') _this.$router.push('/verbruik')
        if(_this.$route.name == 'resultatenPage') _this.$router.push('/')

        history.pushState(null, document.title, location.href)
      })
    },
  },

}
</script>

<style lang="scss">
  html {
    box-sizing: border-box;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
  body {
    margin: 0;
  }
  #app {
    position: fixed;
    display: flex;
    flex-direction: column;
    align-content: center;
    margin: 0;
    width: 100%;
    height: auto;
    min-height: 100vh;
    background-color: $color-yellow-1;
    top: -100vh;
    transition: all .5s;
    z-index:999;

    &.open {
      top: 0;
      transition: all .5s;
    }

    .app-row {
      margin: auto;
      width: 100%;
      max-width: 960px;
      padding-left: 40px;
      padding-right: 40px;
    }
    button, a {
      cursor: pointer;
    }
  }
</style>
